import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Exclamation = props => {
  return (
    <SvgIcon {...props}>
      <path fill="none" d="M0 0h24v24H0Z" />
      <path d="M18.789 5.213A9.6 9.6 0 1 1 12 2.4a9.6 9.6 0 0 1 6.789 2.813Zm-1.274 12.3A7.808 7.808 0 1 0 12 19.8a7.809 7.809 0 0 0 5.515-2.283Zm-4.164-9.879v4.8a1.351 1.351 0 1 1-2.7 0v-4.8a1.351 1.351 0 0 1 2.7 0Zm-.016 8.7A1.335 1.335 0 1 1 12 14.969a1.349 1.349 0 0 1 1.335 1.368Z" />
    </SvgIcon>
  );
};

export default SvgI24Exclamation;
